import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <header className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center">
        <Link to="/" className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
            <i className="ri-film-line text-xl text-background-50"></i>
          </span>
          <span className="text-lg font-bold text-foreground-950">
            午夜<span className="text-primary-500">电影网</span>
          </span>
        </Link>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20 relative overflow-hidden">
        <p className="font-label text-[8rem] md:text-[14rem] leading-none text-accent-700 select-none">
          404
        </p>
        <h1 className="text-2xl md:text-3xl font-black text-foreground-950 -mt-6 md:-mt-10 mb-3 relative z-10">
          页面走丢了
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mb-2">
          抱歉，你访问的页面不存在或已被移动。
        </p>
        <p className="text-xs text-foreground-500 font-mono mb-8 break-all max-w-md">{location.pathname}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/movies"
            className="px-5 py-2.5 rounded-md border border-background-400/60 hover:border-primary-500 text-foreground-900 text-sm font-medium transition-colors whitespace-nowrap"
          >
            浏览电影
          </Link>
        </div>
      </main>
    </div>
  );
}